// extracted by mini-css-extract-plugin
module.exports = {"userPage":"userPage_userPage__2G4p1"};